import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider, Hydrate } from '@tanstack/react-query';
import { CurrencyProvider, DefaultProviders, ToastProvider, isServer } from '@phishtool/ui';
import { queryClient } from '~service';
import theme from '~styles/theme';
import { ModalProvider } from '@phishtool/modal';
const Providers = ({ children, staticData, query }) => {
    const queryClientToUse = isServer ? new QueryClient() : queryClient;
    return (_jsx(QueryClientProvider, { client: queryClientToUse, children: _jsx(Hydrate, { state: query, children: _jsx(ToastProvider, { value: staticData.toast || null, children: _jsx(CurrencyProvider, { children: _jsx(DefaultProviders, { theme: theme, staticData: staticData, children: _jsx(ModalProvider, { blurBackground: true, listenToFragment: true, children: children }) }) }) }) }) }));
};
export default Providers;
